import { useQuery, useQueryClient } from "@tanstack/react-query";
import API from "@src/API";
import { queryKeys } from "./keys";

function asArray(value) {
  return Array.isArray(value) ? value : [];
}

async function fetchConnections() {
  const resp = await API.getAsync("/Person/Connections");
  if (!resp?.ok) {
    throw new Error(resp?.jsonData?.message || resp?.jsonData?.error || "Could not load connections");
  }
  const data = resp.jsonData || {};
  return {
    connections: asArray(data.connections),
    people: asArray(data.people),
  };
}

export function useConnectionsQuery(options = {}) {
  return useQuery({
    queryKey: queryKeys.connections(),
    queryFn: fetchConnections,
    staleTime: 30_000,
    ...options,
  });
}

export async function refreshConnections(queryClient) {
  await queryClient.invalidateQueries({ queryKey: queryKeys.connections() });
  await queryClient.refetchQueries({ queryKey: queryKeys.connections() });
}

export function useRefreshConnections() {
  const queryClient = useQueryClient();
  return () => refreshConnections(queryClient);
}
